import {FETCH_CAT_POSTS, FETCH_TAG_POSTS, FETCH_ALL_POSTS, FETCH_POSTS, FETCH_POST, SEARCH_POSTS, CATEGORY_POSTS} from '../actions';

export default (state = [], action) => {
    switch (action.type) {
        case FETCH_CAT_POSTS:
        case FETCH_TAG_POSTS:
        case FETCH_ALL_POSTS:
        case FETCH_POSTS:
        case FETCH_POST:
        case SEARCH_POSTS:
        case CATEGORY_POSTS:
            return action.payload;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/posts-reducer.js